const card2Container = document.querySelector(".cards-2-container");

const featuresContainer = document.querySelector(".features-container");

if (card2Container) {
  card2Container.addEventListener("click", (e) => {
    const module = e.target.closest(".card-2");

    if (!module) return;

    const featureId = module.getAttribute("id");

    document.querySelectorAll(".section--feature").forEach((section) => {
      section.classList.remove("show");
    });

    document.querySelector(`#${featureId}-text`).classList.add("show");
  });
}
